import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSelect,
} from "@coreui/react";
import React, { useState } from "react";
import { formatDate } from "src/shared/Format/dateFormat";
import { apiCall } from "src/_apiConfig/apiCall";

const LotCompleteDetails = () => {
  const year = 1900;
  const [collectionSeason, setcollectionSeason] = useState(
    new Date().getFullYear()
  );
  const [lotNo, setlotNo] = useState("");
  const [lotDetails, setlotDetails] = useState([]);
  const [tenderDetails, settenderDetails] = useState([]);
  const [transferDetails, settransferDetails] = useState([]);
  const getLotDetails = async () => {
    if (lotNo && collectionSeason) {
      const header = new Headers();
      const response = await apiCall(
        `LotDetails/getLotDetails?$filter=lotNo eq '${lotNo}'`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();
      if (response.status === 200) {
        setlotDetails(jsonobj);

        var arr = [];
        const promises = jsonobj.map((data) => {
          return apiCall(
            `Tender?$filter=tenderId eq ${data.tenderId} and contains(collectionSeason,'${collectionSeason}')`,
            "GET",
            header,
            null
          )
            .then((responseData) => responseData.json())
            .then((jsonobjData) => arr.push(jsonobjData[0]));
        });
        Promise.all(promises).then(() =>
          settenderDetails((oldData) => {
            console.log(arr);
            return arr;
          })
        );

        const promisesTrans = jsonobj.map((data) =>
          apiCall(
            `LotTransfer?$filter=lotId eq ${data.lotId}`,
            "GET",
            header,
            null
          ).then((responseData) => responseData.json())
        );

        Promise.all(promisesTrans).then((data) => {
          data.map((d) => {
            if (d.length > 0) {
              settransferDetails(d);
              console.log("tranfer", d);
            }
          });
        });
      }
    }
  };
  // useEffect(() => {}, [tenderDetails]);
  return (
    <>
      <CCard>
        <CCardBody>
          <h3 className="">Lot Complete Details</h3>
          <hr />
          <CRow>
            <CCol xl={3}>
              <CLabel>Lot number</CLabel>
              <CInput type="text" onChange={(e) => setlotNo(e.target.value)} />
            </CCol>
            <CCol xl={3}>
              <CLabel>Collection Season</CLabel>
              <CSelect
                value={collectionSeason}
                id="validationCustom03"
                onChange={(e) => setcollectionSeason(e.target.value)}
              >
                {Array.from(new Array(200), (v, i) => (
                  <option key={i} value={year + i}>
                    {year + i}
                  </option>
                ))}
              </CSelect>
            </CCol>
            <CCol xl={3}>
              <CButton
                onClick={getLotDetails}
                style={{ marginTop: "1.8rem" }}
                color="primary"
              >
                Submit
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      {lotDetails.length > 0 &&
        tenderDetails.length > 0 &&
        tenderDetails[0] !== undefined &&
        lotDetails.map((lot, index) => (
          <CCard>
            <CCardBody>
              <h4>Lot Details </h4>
              <hr />
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">EmailID :</CLabel>

                  <CInput
                    value={lot.emailId === null ? " " : lot.emailId}
                    disabled
                  />
                </CCol>
                <CCol className="" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Company Name :
                  </CLabel>
                  <CInput
                    value={lot.companyName === null ? " " : lot.companyName}
                    disabled
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel>Date :</CLabel>
                  <CInput
                    value={
                      lot.datetime === undefined
                        ? " "
                        : formatDate(lot.datetime)
                    }
                    disabled
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Lot number :
                  </CLabel>
                  <CInput
                    value={lot.lotNo === null ? " " : lot.lotNo}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Quantity :</CLabel>
                  <CInput
                    value={lot.quantity === null ? " " : lot.quantity}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Rate :
                  </CLabel>
                  <CInput
                    value={lot.purchaseRate === null ? " " : lot.purchaseRate}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Price :
                  </CLabel>
                  <CInput
                    value={lot.purchasePrice === null ? " " : lot.purchasePrice}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Status :</CLabel>
                  <CInput
                    value={lot.status === null ? " " : lot.status}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Emd Amount :{" "}
                  </CLabel>
                  <CInput
                    value={lot.emdAmount === null ? " " : lot.emdAmount}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Society : </CLabel>
                  <CInput
                    value={lot.socity === null ? " " : lot.socity}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    District Union :{" "}
                  </CLabel>
                  <CInput
                    value={lot.districtName === null ? " " : lot.districtName}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Circle Name :{" "}
                  </CLabel>
                  <CInput
                    value={lot.circleName === null ? " " : lot.circleName}
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
            </CCardBody>

            {tenderDetails.length > 0 && tenderDetails[index] && (
              <CCardBody>
                <h4>Tender Details </h4>
                <hr />
                <CRow className="mt-3">
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Tender number :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].tenderNo &&
                        tenderDetails[index].tenderNo === undefined
                          ? " "
                          : tenderDetails[index].tenderNo
                      }
                      disabled
                      id="exampleFormControlInp ut1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Details :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].details === null
                          ? " "
                          : tenderDetails[index].details
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Publish Date :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].purchaseDate === undefined
                          ? " "
                          : formatDate(tenderDetails[index].purchaseDate)
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Rebate(%) :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].rebate === null
                          ? " "
                          : tenderDetails[index].rebate
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Late Fee Per Day(%) :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].lateFeePerDay === null
                          ? " "
                          : tenderDetails[index].lateFeePerDay
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Security Deposit Amount :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].securityDepositAmount === null
                          ? " "
                          : tenderDetails[index].securityDepositAmount
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Security Deposit Day :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].securityDepositDay === null
                          ? " "
                          : tenderDetails[index].securityDepositDay
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Total Lots :
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].totalLots === null
                          ? " "
                          : tenderDetails[index].totalLots
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={4}>
                    <CLabel htmlFor="exampleFormControlInput1">
                      Collection Season :{" "}
                    </CLabel>
                    <CInput
                      value={
                        tenderDetails[index].collectionSeason === null
                          ? " "
                          : tenderDetails[index].collectionSeason
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  {[...Array(tenderDetails[index].paymentSlots)].map((e, i) => (
                    <>
                      <CCol className="mb-2" xl={4}>
                        <CLabel
                          key={`Payment Due Date label ${i + 1}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          {`Payment Due Date ${i + 1}`} :
                        </CLabel>
                        <CInput
                          key={`Payment Due Date input ${i + 1}`}
                          value={
                            tenderDetails[index].paymentDueDates[i]
                              .paymentDueDate === undefined
                              ? " "
                              : formatDate(
                                  tenderDetails[index].paymentDueDates[i]
                                    .paymentDueDate
                                )
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                      <CCol className="mb-2" xl={2}>
                        <CLabel
                          key={`Payment Complete label ${i + 1}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          {`Payment ${i + 1} Complete`} :
                        </CLabel>
                        <CInput
                          key={`Payment Complete input ${i + 1}`}
                          value={
                            tenderDetails[index].paymentDueDates[i]
                              .paymentComplete === null
                              ? " "
                              : tenderDetails[index].paymentDueDates[i]
                                  .paymentComplete
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                      <CCol className="mb-2" xl={2}>
                        <CLabel
                          key={`Payment Completed Amount ${i + 1}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          {`Payment ${i + 1} Amount`} :
                        </CLabel>
                        <CInput
                          key={`Payment percentage input ${i + 1}`}
                          value={
                            tenderDetails[index].paymentDueDates[i]
                              .paymentComplete === null
                              ? " "
                              : (
                                  (tenderDetails[index].paymentDueDates[i]
                                    .paymentComplete /
                                    100) *
                                  lot.purchasePrice
                                ).toFixed(2)
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                      <>
                        <CCol className="mb-2" xl={2}>
                          <CLabel
                            key={`Teminate Date label ${i + 1}`}
                            htmlFor="exampleFormControlInput1"
                          >
                            {`Teminate Date`} :
                          </CLabel>
                          <CInput
                            key={`Payment percentage input ${i + 1}`}
                            value={
                              tenderDetails[index].paymentDueDates[i]
                                .terminationDate === undefined
                                ? " "
                                : formatDate(
                                    tenderDetails[index].paymentDueDates[i]
                                      .terminationDate
                                  )
                            }
                            disabled
                            id="exampleFormControlInput1"
                          />
                        </CCol>
                      </>

                      <CCol xl={2} className="mt-4"></CCol>
                    </>
                  ))}
                </CRow>
              </CCardBody>
            )}
            {transferDetails.length > 0 && (
              <CCardBody>
                {transferDetails
                  .filter((data) => data.lotId === lot.lotId)
                  .map((data, key) => (
                    <div className="">
                      {key === 0 && (
                        <>
                          <h4>Tranfer Details </h4>
                          <hr />
                        </>
                      )}
                      <div>
                        <CRow className="mt-3">
                          <CCol className="mb-2" xl={3}>
                            <CLabel
                              htmlFor="exampleFormControlInput1"
                              key={`label${key}`}
                            >
                              Transferor :
                            </CLabel>
                            <CInput
                              key={`Transfer from user${key}`}
                              value={
                                data.transferFromUser === null
                                  ? " "
                                  : data.transferFromUser
                              }
                              disabled
                              id="exampleFormControlInput1"
                            />
                          </CCol>
                          <CCol className="mb-2" xl={3}>
                            <CLabel
                              key={`label Transfer to user${key}`}
                              htmlFor="exampleFormControlInput1"
                            >
                              Transferee:
                            </CLabel>
                            <CInput
                              key={`Transfer to user${key}`}
                              value={
                                data.transferToUser === null
                                  ? " "
                                  : data.transferToUser
                              }
                              disabled
                              id="exampleFormControlInput1"
                            />
                          </CCol>
                          <CCol className="mb-2" xl={2}>
                            <CLabel
                              key={`label Request Date${key}`}
                              htmlFor="exampleFormControlInput1"
                            >
                              Request Date :
                            </CLabel>
                            <CInput
                              key={`Request Date${key}`}
                              value={
                                data.requestDateTime === undefined
                                  ? " "
                                  : formatDate(data.requestDateTime)
                              }
                              disabled
                              id="exampleFormControlInput1"
                            />
                          </CCol>
                          <CCol className="mb-2" xl={2}>
                            <CLabel
                              key={`label Request Update Date${key}`}
                              htmlFor="exampleFormControlInput1"
                            >
                              Request Update Date :
                            </CLabel>
                            <CInput
                              key={`Request Update Date${key}`}
                              value={
                                data.requestUpdateDateTime === undefined
                                  ? " "
                                  : formatDate(data.requestUpdateDateTime)
                              }
                              disabled
                              id="exampleFormControlInput1"
                            />
                          </CCol>
                          <CCol className="mb-2" xl={1}>
                            <CLabel
                              key={`label span${key}`}
                              htmlFor="exampleFormControlInput1"
                            >
                              Status :
                            </CLabel>
                            <h5>
                              {data.status === null ? (
                                " "
                              ) : data.status === 0 ? (
                                <span
                                  key={`pending-span${key}`}
                                  className="badge bg-warning text-dark"
                                >
                                  Pending
                                </span>
                              ) : data.status === 1 ? (
                                <span
                                  key={`Accepted-span${key}`}
                                  className="badge bg-success text-light"
                                >
                                  Accepted
                                </span>
                              ) : (
                                <span
                                  key={`Rejected-span${key}`}
                                  className="badge bg-danger text-light"
                                >
                                  Rejected
                                </span>
                              )}
                            </h5>
                          </CCol>
                          <CCol className="mb-2" xl={1}>
                            <CLabel
                              key={`label approveduser span${key}`}
                              htmlFor="exampleFormControlInput1"
                            >
                              User Approved:
                            </CLabel>
                            <h5>
                              {data.isUserApproved === null ? (
                                <span
                                  key={`pending-span${key}`}
                                  className="badge bg-warning text-dark"
                                >
                                  Pending
                                </span>
                              ) : data.isUserApproved === true ? (
                                <span
                                  key={`Accepted-span${key}`}
                                  className="badge bg-success text-light"
                                >
                                  Accepted
                                </span>
                              ) : (
                                <span
                                  key={`Rejected-span${key}`}
                                  className="badge bg-danger text-light"
                                >
                                  Rejected
                                </span>
                              )}
                            </h5>
                          </CCol>
                        </CRow>
                      </div>
                    </div>
                  ))}
              </CCardBody>
            )}
          </CCard>
        ))}
    </>
  );
};

export default LotCompleteDetails;
